const RE_LOGIN = 100000
const TIMEOUT = 100004
const AUTHORIZATION_EXPIRE = 100005
const UNAUTHORIZED = 100006

export const requestFilter = [RE_LOGIN , TIMEOUT , AUTHORIZATION_EXPIRE]

export const requireNoticeCode = [UNAUTHORIZED]